module.exports = {"failed":"Het inloggen is mislukt","success":"Het inloggen is geslaagd"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/nl/auth.json
// module id = 244
// module chunks = 1